import './index.css';
import React from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var styles = {"styles":"politico_style____BWzQKbF-p"};

var Comments =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Comments, _React$PureComponent);

  function Comments() {
    _classCallCheck(this, Comments);

    return _possibleConstructorReturn(this, _getPrototypeOf(Comments).apply(this, arguments));
  }

  _createClass(Comments, [{
    key: "render",
    value: function render() {
      var publishPath = this.props.publishPath;
      return React.createElement("section", {
        className: classnames('comments', styles.styles)
      }, React.createElement(Helmet, null, React.createElement("script", null, "// Facebook Comments Script\n              (function(d, s, id) {\n                var js, fjs = d.getElementsByTagName(s)[0];\n                if (d.getElementById(id)) return;\n                js = d.createElement(s); js.id = id;\n                js.src = \"//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.9&appId=178201668917374\";\n                fjs.parentNode.insertBefore(js, fjs);\n              }(document, 'script', 'facebook-jssdk'));\n            ")), React.createElement("div", {
        className: "fb-comments",
        "data-href": "https://www.politico.com/".concat(publishPath),
        "data-numposts": "5"
      }), React.createElement("div", {
        id: "fb-root"
      }));
    }
  }]);

  return Comments;
}(React.PureComponent);

export default Comments;
